// extracted by mini-css-extract-plugin
export default {"inputValue":"input_inputValue__ZuLwT"};